import React from 'react';
import PropTypes from 'prop-types';

export const FxAdditionalButton = ({
  additionalText,
  additionalTextTheme,
  isDisabled,
  onAdditionalTextClick,
}) => {
  const defaultTheme = 'dls-bright-blue icon-link icon-hover';
  return (
    <span
      className={
        isDisabled ? 'disabled' : additionalTextTheme || defaultTheme
      }
      tabIndex="0"
      role="button"
      onKeyPress={isDisabled ? null : onAdditionalTextClick}
      onClick={isDisabled ? null : onAdditionalTextClick}
    >
      {additionalText}
    </span>
  );
};

FxAdditionalButton.propTypes = {
  additionalText: PropTypes.string.isRequired,
  additionalTextTheme: PropTypes.string,
  isDisabled: PropTypes.bool.isRequired,
  onAdditionalTextClick: PropTypes.func.isRequired,
};
